import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=84c5d616&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=84c5d616&prod&lang=sass&scoped=true&"
import style1 from "./Modal.vue?vue&type=style&index=1&id=84c5d616&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c5d616",
  null
  
)

export default component.exports